import React, { useState, useEffect } from "react";
import { createFilter } from "react-select";
import AsyncSelect from "react-select/async";
import { Label } from "reactstrap";
import PhoneNumberService from "core/api/PhoneNumberService";

export const PhoneNumberSelectorInputComponent = ({
  value,
  onChange,
  fieldError,
  fieldTouched,
  label,
  ...props
}) => {
  const [selected, setSelected] = useState(null);

  const filterNumbers = async (inputValue) => {
    const responseData = await PhoneNumberService.filterByNumber(inputValue);

    if (responseData.model.length === 0) return null;

    return responseData.model.map((phoneNumber) => ({
      value: phoneNumber.id,
      number: phoneNumber.phoneNumber,
      name: phoneNumber.name
    }));
  };

  const loadOptions = (inputValue, callback) => {
    setTimeout(async () => {
      var items = await filterNumbers(inputValue);
      callback(items);
    }, 1000);
  };

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
  };

  useEffect(() => {
    async function fetchData() {
      const phoneNumber = await PhoneNumberService.get(value)
      setSelected({ value: value, number: phoneNumber.phoneNumber, name: phoneNumber.name })
    }
    if (value) {
      fetchData();
    }
  }, [])


  return (
    <div>
      {label && <Label>{label}</Label>}

      <AsyncSelect
        value={selected}
        filterOption={createFilter(filterConfig)}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        {...props}
        onChange={(option) => {
          setSelected(option ? { value: option.value, number: option.number, name: option.name } : null)
          if (onChange) {
            onChange(option?.value)
          }
        }}
        getOptionLabel={(option) => `${option.number} - ${option.name}`}
        isClearable
      />
      {fieldTouched && fieldError && (
        <div className="error">{fieldError}</div>
      )}
    </div>
  );
};


export const PhoneNumberSelectorInputComponentFormik = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  return (
    <PhoneNumberSelectorInputComponent
      {...props}
      value={field.value}
      onChange={(newValue) => setFieldValue(field.name, newValue)}
      error={errors[field.name]}
      touched={touched[field.name]}
    />
  );
}